module.exports = __webpack_public_path__ + "img/01-128.e998d23f.png";